import Device from './Device';

/** Class representing a printer. */
class Printer extends Device {
    static PROFILE_CARD          = 1;   // 00000001;
    static PROFILE_THERMAL       = 2;   // 00000010;
    static PROFILE_OTHER         = 4;   // 00000100;
    static PROFILE_OPT_HOLE      = 8;   // 00001000;
    static PROFILE_OPT_CUTTER    = 16;  // 00010000;
    static PROFILE_OPT_CUT_WHOLE = 32;  // 00100000;
    static PROFILE_OPT_COLOR     = 64;  // 01000000
    static PROFILE_OPT_DUPLEX    = 128; // 10000000

    /**
     * List of available profiles
     * ==========================
     *
     * 10  => 00001010  Thermal printer (type ZDxx or ZX) with hole paper without cutter
     * 3   => 00000010  Thermal printer (type ZDxx or ZX) with continuous paper without cutter
     * 18  => 00010010  Thermal printer (type ZDxx or ZX) with continuous paper and cutter (cut after each ticket)
     * 26  => 00011010  Thermal printer (type ZDxx or ZX) with hole paper and cutter (cut after each ticket)
     * 50  => 00110010  Thermal printer (type ZDxx or ZX) with continuous paper and cutter (cut after the whole document)
     * 58  => 00111010  Thermal printer (type ZDxx or ZX) with hole paper and cutter (cut after the whole document)
     * 1   => 00000001  Card printer (type ZCxxx) with Black Ribbon and Duplex disabled
     * 65  => 01000001  Card printer (type ZCxxx) with Color Ribbon and Duplex disabled
     * 129 => 10000001  Card printer (type ZCxxx) with Black Ribbon and Duplex enabled
     * 193 => 11000001  Card printer (type ZCxxx) with Color Ribbon and Duplex enabled
     * 4   => 00000100  Other standard printer
     * 6   => 00000110  Other thermal printer
     */

    getIconName() {
        return 'print';
    }

    isCardPrinter() {
        return this.options?.profile & Printer.PROFILE_CARD;
    }
}

export default Printer;
